import './App.css';
import './assets/css/visualizations.css';
import 'leaflet/dist/leaflet.css';
import { CookiesProvider } from "react-cookie";
import Kashika1 from './layouts/kashika1';
import Kashika2 from './layouts/kashika2';
import Kashika3 from './layouts/kashika3';
import Kashika4 from './layouts/kashika4';
import Kashika5 from './layouts/kashika5';
import Kashika6 from './layouts/kashika6';
import Kashika7 from './layouts/kashika7';
import Kashika8 from './layouts/kashika8';

const App = () => {
  
  const changeContents = () => {
    
    if (process.env.REACT_APP_KASHIKA == 1) {
      return <Kashika1 />
    } else if (process.env.REACT_APP_KASHIKA == 2) {
      return <Kashika2 />
    } else if (process.env.REACT_APP_KASHIKA == 3) {
      return <Kashika3 />
    } else if (process.env.REACT_APP_KASHIKA == 4) {
      return <Kashika4 />
    } else if (process.env.REACT_APP_KASHIKA == 5) {
      return <Kashika5 />
    } else if (process.env.REACT_APP_KASHIKA == 6) {
      return <Kashika6 />
    } else if (process.env.REACT_APP_KASHIKA == 7) {
      return <Kashika7 />
    } else if (process.env.REACT_APP_KASHIKA == 8) {
      return <Kashika8 />
    }
  }
  
  return (
    <div id="app">
      <CookiesProvider>
        { changeContents() }
      </CookiesProvider>
    </div>
  );
}

export default App;
